import React, { useRef, useEffect, useState } from "react";
import PreviewCompatibleImage from "../Utils/PreviewCompatibleImage";
import Section from "../Layout/Section/Section";
import InnerContainer from "../Layout/InnerContainer/InnerContainer";
import Carousel from "../Carousel/Carousel";

import "./photo-grid.scss";

const PhotoGrid = ({ id, gridImages }) => {
  const [currSlide, setCurrSlide] = useState(0);

  function renderGridImages(gridImages) {
    if (!gridImages) {
      return;
    }

    const gridImagesHTML = [];
    const delays = [0, 100, 200, 300];
    let delayIndex = 0;

    gridImages.forEach((gridImage, i) => {
      let starred = "";
      let featuredClass = "";
      const animationDelay = {
        animationDelay: `${delays[delayIndex]}ms`,
      };

      if (delayIndex < 4) {
        delayIndex++;
      } else {
        delayIndex = 0;
      }

      if (gridImage.featured) {
        featuredClass = "grid-image__container--featured";
        if (gridImage.image.childImageSharp.fluid.aspectRatio < 0.75) {
          featuredClass =
            "grid-image__container--featured grid-image__container--featured--portrait";
        }
      }

      gridImagesHTML.push(
        <div
          key={i}
          id={i}
          style={animationDelay}
          onClick={handleGridImageClick}
          className={`grid-image__container ${featuredClass}`}
        >
          {renderCaption(gridImage.caption)}
          <PreviewCompatibleImage
            customClass={`grid-image ${
              gridImage.featured ? "grid-image--featured" : ""
            }`}
            imageInfo={gridImage.image}
            alt="grid image"
          />
        </div>
      );
    });
    return gridImagesHTML;
  }

  const renderCaption = (caption) => {
    if (caption) {
      return <p className="caption">{caption}</p>;
    }
  };

  const handleGridImageClick = (e) => {
    // console.log("handleGridImageClick", gridModalClose.current);
    // currSlide = e.currentTarget.id;
    setCurrSlide(e.currentTarget.id);
    toggleModel();
  };
  
  const toggleModel = () => {
    // console.log("closeModel");
    document.querySelector("html").classList.toggle("modal-active");
    // gridModalClose.current.addEventListener("click", toggleModel, true);
  }

  const renderShaddowCarousel = (gridImages) => {
    return (
      <div ref={gridModalClose} className="modal"><button className="close" onClick={toggleModel}>+</button><Carousel currentSlide={currSlide} videoSlides={gridImages}/></div>
    )
  };

  const gridModalClose = useRef();

  return (
    <Section id={id} customClass="photo-grid__container">
        {renderShaddowCarousel(gridImages)}
      <InnerContainer customClass="photo-grid">
        {renderGridImages(gridImages)}
      </InnerContainer>
    </Section>
  );
};

export default PhotoGrid;
